module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNmMyZDQxOTdjYTkwMWEyN2E0OTM3YTdkNzMwYWY2NzIucG5nIjs="